export default __webpack_public_path__ + "static/media/home.37ad3383.svg";